import { combineReducers } from "redux";
import { configureStore } from '@reduxjs/toolkit';

import { userLoginReducer } from "./Reducers/authReducers";
import { orderDetailsReducer } from "./Reducers/ordersReducers";

const rootReducer = combineReducers({
  auth: userLoginReducer,
  orders: orderDetailsReducer,
});

const authFromLocalStorage = localStorage.getItem("auth")
  ? JSON.parse(localStorage.getItem("auth"))
  : { didLogout: false };

const initialState = {
  auth: authFromLocalStorage,
};

const store = configureStore ({
  reducer: rootReducer,
  preloadedState: initialState
});

export default store;
